import { mergeDeep } from '@/helpers/utils'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

export default (schemas: LandingScreenSchema[]): LandingScreenSchema[] => {
	const extensionSchema: Partial<LandingScreenSchema>[] = [
		// loader-chair-tai-chi-m — "Chair" → "Seated" (image/loader/footer preserved by mergeDeep)
		{
			components: {
				LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
					title: 'Seated Tai Chi for Beginners Based on Your Age',
					size: 'small',
				}),
			},
		},
		// age-chair-tai-chi-m — "CHAIR" → "SEATED". Overriding the component fn replaces it wholesale,
		// so the `note` must be re-emitted (alert/age-grid are untouched → preserved by mergeDeep).
		{
			components: {
				LandingTitleExtended: ({ $t }): LandingComponentsConfig['LandingTitleExtended'] => ({
					title: 'SEATED Tai Chi<br/>for BEGINNERS',
					note: $t('female_yoga.pages.landing.quiz'),
				}),
			},
		},
	]

	return mergeDeep([...schemas], extensionSchema)
}
